import React from "react";
import "./DragMouseToMoveMessage.css";

const DragMouseToMoveMessage = ({isVisible}) => {
    return (
        <div id="drag-mouse-to-move-message" style={{display: isVisible ? 'block' : 'none' }}>Drag to move viewpoint</div>
    );
};

export default DragMouseToMoveMessage;